import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-button-play',
  templateUrl: './button-play.component.html',
  styleUrls: ['./button-play.component.less']
})
export class ButtonPlayComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
